(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/best-bet-rows/assets/javascripts/use-single-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/best-bet-rows/assets/javascripts/use-single-rows.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const helpers = svs.components.tipsen.store.helpers;
const useGetPlayerWagerQuery = svs.components.tipsen.store.tipsenApi.useGetPlayerWagerQuery;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const defaultReturn = [];
const useSingleRows = function (_ref) {
  var _productBet$gameBoard, _productBet$gameBoard2;
  let wagerId = _ref.wagerId;
  let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$skip = _ref2.skip,
    skip = _ref2$skip === void 0 ? false : _ref2$skip;
  const wager = useGetPlayerWagerQuery({
    wagerId
  }, {
    skip: !wagerId
  });
  const _ref3 = wager.data || {},
    productBet = _ref3.productBet;
  const _ref4 = (_productBet$gameBoard = productBet === null || productBet === void 0 || (_productBet$gameBoard2 = productBet.gameBoard) === null || _productBet$gameBoard2 === void 0 ? void 0 : _productBet$gameBoard2.boards) !== null && _productBet$gameBoard !== void 0 ? _productBet$gameBoard : {},
    boardData = _ref4.boardData,
    systemType = _ref4.systemType,
    systemNum = _ref4.systemNum;
  const productId = productBet.productId;
  const eventTypeId = productId ? getDefinitionByProduct(productId).outcomes.eventTypeId : 0;
  const srow = useMemo(() => {
    if (skip || !boardData) {
      return defaultReturn;
    }
    return helpers.getExpandedRows(boardData, systemType, systemNum, {
      eventTypeId
    });
  }, [boardData, systemType, systemNum, eventTypeId, skip]);
  return srow;
};
setGlobal('svs.tipsen.components.bestBetRows.useSingleRows', useSingleRows);

 })(window);